import React, { useEffect, useState } from 'react'
import "./Nav.css"
import { useNavigate } from 'react-router-dom';

function Nav() {
    const [show, handleshow] = useState(false);
    const navigate = useNavigate()

    const transitionNavbar = () => {
        if (window.scrollY > 100) {
            handleshow(true);
        } else {
        handleshow(false);
        }
    }

    useEffect( () => {
        window.addEventListener("scroll", transitionNavbar)
        return () => window.removeEventListener("scroll", transitionNavbar)

    }, []);
  return (
    <div className= {`nav ${show ? "nav-black" : ""}`}>
        <div className='nav-contents'>
        
        <img
         onClick={() => navigate("/")}
            className='nav-logo'
         src='https://images.ctfassets.net/y2ske730sjqp/6bhPChRFLRxc17sR8jgKbe/6fa1c6e6f37acdc97ff635cf16ba6fb3/Logos-Readability-Netflix-logo.png' alt=''/>
      <img
      onClick={() => navigate("/profile")} className='nav-avatar'
       src='https://wallpapers.com/images/hd/netflix-profile-pictures-1000-x-1000-qo9h82134t9nv0j0.jpg' alt=''/>        
        </div>
      
    </div>
  )
}

export default Nav
